/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber7 = createReactComponent("number-7", "IconNumber7", [
  ["path", { d: "M8 4h8l-4 16", key: "svg-0" }]
]);

export { IconNumber7 as default };
//# sourceMappingURL=IconNumber7.js.map
